module.exports = __webpack_public_path__ + "static/media/timro rang pani khojney hai.4103ff6d.wav";